module.exports = __webpack_public_path__ + "img/sanfei_bg.14ab86bc.png";